<template>
    <woot-modal :show.sync="show" :on-close="onClose">
        <div class="column content-box">
            <woot-modal-header :header-title="headerTitle" />

            <div>
                <div class="main-form">
                    <div>
                        <span class="span-label">
                            <form>
                            <div v-if="!selectedContact">
                                <div class="modal-footer"></div>
                                <input ref="searchInput" type="text" :placeholder="$t('SURVEY_MGMT.SURVEY.SEND_PLACEHOLDER')
                                    " :value="searchQuery" @input="debounceSearch" />
                                <div v-if="queryConversation">
                                    <ul class="search-list">
                                        <li v-for="contact in contacts" :key="contact.id">
                                            <search-result-contact-item :id="contact.id" :name="contact.name"
                                                :email="contact.email" :phone="contact.phone_number"
                                                :account-id="accountId" :thumbnail="contact.thumbnail" :redirect="false"
                                                @click.native="selectContact(contact)" />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="selectedContact && sendType == 'email'">
                                <textarea class="input-text" :value="survey.message"/>
                                <button class="button clear" @click.prevent="removeSelectedContact">
        {{ $t('SURVEY_MGMT.SURVEY.SEND_BACK') }}
      </button>
                                <woot-button @click="sendToEmail">{{ $t('SURVEY_MGMT.SURVEY.SEND_BUTTON') }}</woot-button>
                            </div>
                            <div v-if="selectedContact && sendType == 'whatsapp'">
                                <conversation-form
                                    :contact="selectedContact" :survey="survey" :is-survey=true :on-submit="onSubmit" @cancel="onClose" @success="onClose"
                                />
                            </div>
                        </form>
                        </span>
                        <div class="modal-footer"></div>
                    </div>
                </div>
            </div>
        </div>
    </woot-modal>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { mapGetters } from 'vuex';
import { CONVERSATION_EVENTS } from '../../../../helper/AnalyticsHelper/events';
import SearchResultContactItem from '../../../../modules/search/components/SearchResultContactItem.vue'
import TextArea from '../../../../../shared/components/TextArea.vue';
import WootButton from '../../../../components/ui/WootButton.vue';
import getUuid from '../../../../../widget/helpers/completeUuid';
import ConversationForm from '../../conversation/contact/ConversationForm.vue';
import contacts from '../../../../api/contacts';

export default {
    mixins: [alertMixin],
    components: {
        SearchResultContactItem,
        TextArea,
        WootButton,
        ConversationForm
    },
    props: {
        survey: {
            type: Object,
            default: {},
        },
        sendType: {
            type: String,
            default: 'email',
        }
    },
    data() {
        return {
            show: true,
            searchQuery: '',
            selectedContact: '',
        };
    },
    watch: {
        queryConversation: {
            handler(newValue) {
                this.searchQuery = newValue;
                if (newValue === 'close-modal') {
                    this.closeModalFilters();
                }

            },
            immediate: true,
        },
    },
    mounted() {
        this.survey.message = this.messageValue();
    },
    computed: {
        ...mapGetters({
            accountId: 'getCurrentAccountId',
            uiFlags: 'getUIFlags',
            uiFlags: 'conversationSearch/getUIFlags',
            currentUser: 'getCurrentUser',
            indexTab: 'attributes/getIndexTabAttributes',
            contactRecords: 'conversationSearch/getContactRecords',
            queryConversation: 'conversationSearch/getQueryConversation',
        }),
        
        headerTitle() {
            if (this.selectedContact?.name) {
                return `${this.survey.name} - ${this.selectedContact.name}`
            }
            return `${this.survey.name}`
        },
        contacts() {
            return this.contactRecords
                ?.map(contact => ({
                    ...contact,
                    type: 'contact',
                }))
                .filter(contact => !contact?.phone_number?.includes('@g.us'));
        },
    },
    validations: {
    },
    methods: {
        async onSubmit(contactItem) {
      const inbox = this.$store.getters['inboxes/getInbox'](
        contactItem?.inboxId
      );
      if (
        this.currentUser?.message_signature &&
        inbox?.channel_type !== 'Channel::Whatsapp' &&
        contactItem?.message?.content
      ) {
        contactItem.message.content = `${this.currentUser.message_signature} \n\n ${contactItem.message.content}`;
      }
      const data = await this.$store.dispatch(
        'contactConversations/create',
        contactItem
      );
      return data;
    },
        messageValue() {
            return `${this.getUrl()}`
        },
        removeSelectedContact(){
            this.selectedContact = '';
        },
        sendToEmail(){
            const payload = {
                email: this.selectedContact?.email,
                subject: this.messageValue
            }
            this.$store.dispatch('customSurveys/sendMail', payload);

        },
        getUrl() {
            const baseUrl = window.location.origin;
            const url = `${baseUrl}/survey/custom_surveys/${getUuid()}&${this.survey?.uuid}`;
            return url;
        },
        async selectContact(contact) {
            await this.$store.dispatch(
          'contacts/fetchContactableInbox',
          contact?.id
        );
        const contactState = this.$store.getters['contacts/getContact'](
          contact.id
        ); 

                this.selectedContact = {...contact,...contactState};
        },
        debounceSearch(e) {
            this.searchQuery = e.target.value;
            this.$store.dispatch('conversationSearch/setQuery', e.target.value);

            clearTimeout(this.debounce);
            this.debounce = setTimeout(async () => {
                if (this.searchQuery.length > 2 || this.searchQuery.match(/^[0-9]+$/)) {
                    this.onSearch(this.searchQuery);
                }
            }, 500);
        },
        onSearch(q) {
            this.selectedTab = 'all';
            this.query = q;
            if (!q) {
                this.$store.dispatch('conversationSearch/clearSearchResults');
                return;
            }
            this.$track(CONVERSATION_EVENTS.SEARCH_CONVERSATION);
            this.$store.dispatch('conversationSearch/fullSearch', { q });
        },
        onClose() {
            this.$emit('on-close');
        },
    },
};
</script>

<style lang="scss" scoped>
.question-options {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 5px;
}
</style>